import videojs from "video.js";

const videoPopup = document.querySelectorAll(".video-popup");
if (videoPopup != null && videoPopup.length > 0) {
  let pageID = "";
  const video = document.querySelector(".video-popup__wrapper video");
  const player = videojs(video, { autoplay: false });
  const screen = document.querySelector(".video-js");
  const videoPopupBtnOpen = document.querySelector(".btn--video[data-video]");
  const videoPopupBtnClose = document.querySelector(".video-popup__close");

  videoPopupBtnOpen.addEventListener("click", videoPopupOpen);
  videoPopupBtnClose.addEventListener("click", videoPopupClose);
  window.addEventListener("resize", deviceRotation);

  function videoPopupOpen() {
    player.ready(function () {
      const vw = window.innerWidth * 0.8;
      const vh = vw * 0.5625;
      videoPopup[0].style.opacity = 1;
      videoPopup[0].style.zIndex = 9990;

      videoScale(vw, vh);
    });

    pageID = this.dataset.pageId;
    if(pageID) {
      $.get(
        "/wp-json/video/start/",
        { wpId: pageID },
        function (data) {
          player.currentTime(data.start);
          player.play();
        },
        "json"
      );
    } else {
      player.play();
    }
  }

  function deviceRotation() {
    const vw = window.innerWidth * 0.8;
    const vh = vw * 0.5625;
    videoScale(vw, vh);
  }

  function videoPopupClose() {
    player.pause();
    startStop(player, pageID);

    videoPopup[0].style.opacity = 0;
    videoPopup[0].style.zIndex = -1;
  }

  function videoScale(vw, vh) {
    screen.style.height = `${vh}px`;
    screen.style.width = `${vw}px`;
  }

  player.on("pause", function () {
    startStop(player, pageID);
  });

  player.on("ended", function () {
    startStop(player, pageID);
  });
}

function startStop(player, pageID) {
  for (let i = 0; i < player.played().length; i++) {
    const begin = player.played().start(i);
    const end = player.played().end(i);
    sendingStatistics(pageID, begin, end);
  }
}

function sendingStatistics(id, begin, end) {
  let data = {
    wpId: parseInt(id),
    begin: parseInt(begin),
    end: parseInt(end),
  };

  $.ajax({
    url: "/wp-json/video/log",
    type: "POST",
    data: JSON.stringify(data),
    contentType: "application/json",
    complete: callback,
  });

  function callback(response) {
    return response;
  }
}
